import { render, staticRenderFns } from "./defaultDate.vue?vue&type=template&id=89912a02&scoped=true"
import script from "./defaultDate.vue?vue&type=script&lang=js"
export * from "./defaultDate.vue?vue&type=script&lang=js"
import style0 from "./defaultDate.vue?vue&type=style&index=0&id=89912a02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89912a02",
  null
  
)

export default component.exports